import { render } from "./lessonAgeEchart.vue?vue&type=template&id=46d2381e&scoped=true"
import script from "./lessonAgeEchart.vue?vue&type=script&lang=js"
export * from "./lessonAgeEchart.vue?vue&type=script&lang=js"

import "./lessonAgeEchart.vue?vue&type=style&index=0&id=46d2381e&scoped=true&lang=scss"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46d2381e"]])

export default __exports__